import { IGetReportTreinamentoFuncionarioUseCase } from "../../../presentation/useCases/read/get_report_treinamento_funcionario_use_case";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { IReportsRepository } from "../../repositories/reports_repository";
import { ReportData } from "../../models/report_data";
import { ReportMimeType } from "../../../../../common/utils/report_callback";

import dayjs from "dayjs";
import { IGetReportTreinamentoFuncionarioTercUseCase } from "../../../presentation/useCases/read/get_report_treinamento_funcionario_terc_use_case";


export class GetReportTreinamentoFuncionarioTercUseCase implements IGetReportTreinamentoFuncionarioTercUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportTreinamentoFuncionarioTerc(
    requiredMimeType: ReportMimeType | null,
    dataRealizacao: Date,
    local: string,
    instrutor: string,
    conteudoProgramatico: number,
  ): Promise<ReportData> {
    const response = await this.repository.getReportTreinamentoFuncionarioTerc(
      requiredMimeType,
      dataRealizacao,
      local,
      instrutor,
      conteudoProgramatico === 1 ? 'S' : 'N',
    );

    if (requiredMimeType !== 'text/html') {
      const arquivoNome = `treinamento_funcionario_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
